/**
 * View component for displaying a horizontal split view.
 *
 * This contains lots of padding for the left and right-hand sides, and responsive breakpoints
 * to change to a vertical split view on smaller screens.
 */

import React from 'react';

export const HorizontalSplit = ({ children }: { children: [React.ReactNode, React.ReactNode] }) => (
  <div className="tw:flex tw:items-stretch tw:p-4 tw:sm:p-10 tw:lg:p-0 tw:lg:items-stretch tw:lg:justify-between tw:h-full tw:flex-col tw:lg:flex-row">
    <div className="tw:lg:flex-1 tw:lg:h-full tw:lg:p-20 tw:max-w-lg tw:p-4">
      <div className="tw:flex tw:flex-col tw:justify-between tw:gap-6 tw:w-full tw:max-w-lg">
        {children[0]}
      </div>
    </div>
    <div className="tw:flex tw:lg:flex-1 tw:lg:flex-col tw:justify-start tw:items-center tw:p-4 tw:lg:p-20">
      <div className="tw:flex tw:flex-col tw:justify-between tw:gap-6 tw:w-full tw:max-w-4xl">
        {children[1]}
      </div>
    </div>
  </div>
);
